const o = "…";
export {
  o as ELLIPSIS
};
